class QuickView extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      body: 'body',
      modal: '.modal-quick-view',
      modalHolder: '.quick-shop-holder',
      formHolder: '.product-single__form',
      modalFormHolder: '.modal-quick-view .product-single__form',
      productSection: '.product-section',
      thumbs: '.modal-quick-view .product__thumbs',
      thumb: '.modal-quick-view .product__thumb',
      slider: '.modal-quick-view .product__main-photos',
      scroller: '.modal-quick-view .product__thumbs--scroller',
      variantInput: '.variant-input-wrap .variant-input[data-value]',
      variantCheckedInput: '.variant-input input:checked',
      disableBodyClass: 'modal-open',
      modalActiveClass: 'modal--is-active'
    };

    this.viewHandlers = document.querySelectorAll('.js-open-view-modal');
    this.closeButton = this.querySelector('.modal__close');

    this.viewHandlers.forEach((handler) => {
      handler.addEventListener('click', this.open.bind(this));
    });

    this.closeButton.addEventListener('click', this.close.bind(this));
  }

  async open(e) {
    const modal = document.querySelector(this.selectors.modal);
    const body = document.querySelector(this.selectors.body);

    await this.fetchContent(e);
    modal.classList.add(this.selectors.modalActiveClass);
    body.classList.add(this.selectors.disableBodyClass);
    await this.initSlider();
    await this.photoswipe();
    await this.initVideoModal();
    await this.initVariantInputs();
    await this.toggleVariantInputs();
  }

  async fetchContent(e) {
    const modalHolder = document.querySelector(this.selectors.modalHolder);
    let modalUrl = `${theme.routes.home}/products/${e.currentTarget.dataset.handle}?view=modal`;
    let formUrl = `${theme.routes.home}/products/${e.currentTarget.dataset.handle}`;

    modalUrl = modalUrl.replace('//', '/');
    formUrl = formUrl.replace('//', '/');

    const responseModal = await fetch(modalUrl);
    const dataModal = new DOMParser().parseFromString(await responseModal.text(), 'text/html');
    const responseContentModal = dataModal.querySelector(this.selectors.productSection);

    modalHolder.innerHTML = '';
    modalHolder.innerHTML = responseContentModal.innerHTML;

    const responseForm = await fetch(formUrl);
    const dataForm = new DOMParser().parseFromString(await responseForm.text(), 'text/html');
    const responseFormContent = dataForm.querySelector(this.selectors.formHolder);
    const formContent = document.querySelector(this.selectors.modalFormHolder);

    formContent.innerHTML = '';
    formContent.innerHTML = responseFormContent.outerHTML;
  }

  close() {
    const modal = document.querySelector(this.selectors.modal);
    const body = document.querySelector(this.selectors.body);

    modal.classList.remove(this.selectors.modalActiveClass);
    body.classList.remove(this.selectors.disableBodyClass);
  }

  async initSlider() {
    this.thumbnailsSlider = new Swiper(this.selectors.thumbs, {
      spaceBetween: 0,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      direction: 'vertical',
      clickable: false
    });

    this.mainSlider = new Swiper(this.selectors.slider, {
      spaceBetween: 0,
      navigation: {
        nextEl: '.product__thumb-arrow--next',
        prevEl: '.product__thumb-arrow--prev',
      },
      thumbs: {
        swiper: this.thumbnailsSlider,
      },
    });

    AOS.refreshHard();
  }

  async photoswipe() {
    const selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.product-main-slide.swiper-slide-active'
    };

    function Photoswipe(container, sectionId) {
      this.container = document.querySelector(container);
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!this.container || this.container.dataset.zoom === 'false') {
        return;
      }

      if (this.container.dataset.hasSlideshow === 'true') {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click', this.triggerClick.bind(this));
        });
      },

      triggerClick: function(evt) {
        this.items = this.getImageData();

        const image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;

        this.initGallery(this.items, image.dataset.index);
      },

      getChildIndex: function(el) {
        let i = 0;

        while( (el = el.previousSibling) != null ) {
          i++;
        }

        return i + 1;
      },

      getImageData: function() {
        this.images = this.container.querySelectorAll(selectors.images);

        const items = [];
        const options = {};

        this.images.forEach(el => {
          const item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }

          items.push(item);
        });

        return items;
      },

      initGallery: function(items, index) {
        const pswpElement = document.querySelectorAll('.pswp')[0];

        const options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            const thumbnail = items[index].el;
            const rect = thumbnail.getBoundingClientRect();

            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },

      afterChange: function() {
        const index = this.gallery.getCurrentIndex();

        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      }
    });

    new Photoswipe('[data-product-images]', '.pswp');
  }

  async initVideoModal() {
    let youtubePlayer;

    const videoHolderId = 'VideoHolder';
    const selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };

    const youtubeTriggers = document.querySelectorAll(selectors.youtube);
    const mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }

    const videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }

    const modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });

    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });

    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });

    document.addEventListener('modalClose.VideoModal', closeVideoModal);

    function triggerYouTubeModal(evt) {
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();
      modal.open(evt);

      const videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));

      youtubePlayer = new theme.YouTube(videoHolderId,
          {
            videoId: videoId,
            style: 'sound',
            events: {
            onReady: onYoutubeReady
          }
        }
      );
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      const el = evt.currentTarget;
      const player = el.parentNode.querySelector(selectors.mp4Player);
      const playerClone = player.cloneNode(true);

      playerClone.classList.remove('hide');
      videoHolderDiv.append(playerClone);
      modal.open(evt);

      videoHolderDiv.querySelector('video').play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      const match = url.match(regExp);

      return (match&&match[7].length==11)? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  }

  async toggleVariantInputs(e) {
    const variantInputs = document.querySelectorAll(this.selectors.variantInput);

    if (variantInputs.length) {
      const productThumbsArray = [...document.querySelectorAll(this.selectors.thumb)];
      let filteredThumbsNumber;

      if (e) {
        const filteredThumbsFiltered = productThumbsArray.filter((item) => {
          return item.href.includes(e.currentTarget.dataset.value);
        });

        filteredThumbsNumber = filteredThumbsFiltered[0].dataset.index;
      } else if (!filteredThumbsNumber) {
        const variantCheckedInput = document.querySelector(this.selectors.variantCheckedInput);

        const filteredThumbsFiltered = productThumbsArray.filter((item) => {
          return item.href.includes(variantCheckedInput.value);
        });

        filteredThumbsNumber = filteredThumbsFiltered[0].dataset.index;
      }

      this.thumbnailsSlider.slideTo(filteredThumbsNumber);
      this.mainSlider.slideTo(filteredThumbsNumber);
    }
  }

  async initVariantInputs() {
    const variantInputs = document.querySelectorAll(this.selectors.variantInput);

    variantInputs.forEach((input) => {
      input.addEventListener('click', this.toggleVariantInputs.bind(this));
    });
  }
}

customElements.define('quick-view', QuickView);
